import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestMenu = (
  menuId: string,
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> =>
  fetcher<any>(`${apiEndpoints.routes.menu}/${menuId}`, 'GET', token, forceHeader);
